import useTranslations from "hooks/useTranslations"
import Questions from "components/organisms/common/Questions"

export default function SchoolCoursesQuestions() {
  const {
    schoolsTrainingQuestionsTitle,
    schoolsTrainingQuestionsText1,
    schoolsTrainingQuestionsText2,
    schoolsTrainingQuestionsText3,
    schoolsTrainingQuestionsText4,
    schoolsTrainingQuestionsText5,
    schoolsTrainingQuestionsText6,
  } = useTranslations()

  return (
    <Questions
      className="bg-kkm-yellow"
      title={schoolsTrainingQuestionsTitle}
      texts={[
        schoolsTrainingQuestionsText1,
        schoolsTrainingQuestionsText2,
        schoolsTrainingQuestionsText3,
        schoolsTrainingQuestionsText4,
        schoolsTrainingQuestionsText5,
        schoolsTrainingQuestionsText6,
      ]}
    />
  )
}
